<template>
  <el-dialog class="x-password-dialog"
             v-if="dialogFormVisible"
             :closable="hasInitPassword"
             :close-on-click-modal="hasInitPassword"
             :close-on-press-escape="hasInitPassword"
             :title="hasInitPassword ? '修改密码' : '修改初始密码'"
             :visible.sync="dialogFormVisible"
             ref="dialog"
             v-bind="$attrs"
             v-on="$listeners"
             height="280px"
             width="400px">
    <el-tabs v-model="currentTab" type="card">
      <el-tab-pane lazy name="password" label="用旧密码修改">
        <el-form :model="pwdForm"
                 ref="pwdForm"
                 :rules="pwdFormRules"
                 label-width="80px"
        >
          <XFormItem prop="oldPassword" label="旧密码" :icon-right="24">
            <PasswordInput v-model="pwdForm.oldPassword"
                           :show-rule="false"
                           size="mini"
                           type="password"
                           @keyup.enter.native="onPwdFormSubmit"></PasswordInput>
          </XFormItem>
          <XFormItem prop="newPassword" label="新密码" :icon-right="46">
            <PasswordInput v-model="pwdForm.newPassword"
                           size="mini"
                           type="password"
                           @keyup.enter.native="onPwdFormSubmit"></PasswordInput>
          </XFormItem>
          <XFormItem prop="checkPassword" label="确认密码" :icon-right="46">
            <PasswordInput v-model="pwdForm.checkPassword"
                           @keyup.enter.native="onPwdFormSubmit"
                           size="mini"
                           type="password"></PasswordInput>
          </XFormItem>
        </el-form>
      </el-tab-pane>
      <el-tab-pane lazy name="msgcode" label="手机验证码修改">
        <el-form :model="smsCodeForm"
                 ref="smsCodeForm"
                 :rules="smsFormRules"
                 label-width="80px"
        >
          <XFormItem prop="phone" label="手机号">
            <el-input
              v-model="smsCodeForm.phone"
              @keyup.enter.native="onPwdFormSubmit"
              size="mini"
              disabled
              name="resetPasswordPhone"
            ></el-input>
          </XFormItem>
          <SmsCodeInput :phone="smsCodeForm.phone" v-model="smsCodeForm.msgCode"></SmsCodeInput>
          <XFormItem prop="newPassword" label="新密码" :icon-right="46">
            <PasswordInput v-model="smsCodeForm.newPassword"
                           size="mini"
                           type="password"
                           name="resetPasswordPassword"
                           @keyup.enter.native="onPwdFormSubmit"></PasswordInput>
          </XFormItem>
          <XFormItem prop="checkPassword" label="确认密码" :icon-right="46">
            <PasswordInput v-model="smsCodeForm.checkPassword"
                           @keyup.enter.native="onPwdFormSubmit"
                           size="mini"
                           type="password"></PasswordInput>
          </XFormItem>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false" size="mini" v-if="hasInitPassword">取 消</el-button>
      <el-button type="primary"
                 @click="onPwdFormSubmit"
                 size="mini"
                 :disabled="currentTab === 'msgcode' && !smsCodeForm.phone">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 修改密码弹窗
 * @module XPasswordDialog
 *
 */
import {Tabs, TabPane, Form, Button} from 'element-ui';
// import {checkInitPasswordApi, updateMyPasswordApi} from '../../api/passwordApi';
import XFormItem from '@/component/x-form-item/FormItem.vue';
import XDialog from '@/component/x-dialog/Dialog.vue';
import SmsCodeInput from './components/SmsCodeInput';
import PasswordInput from './components/PasswordInput';
import {checkRandomStr, isTrimEmpty} from '@/util/appUtils';
import {getSysUser} from '@/util/user';
const checkInitPasswordApi = () => {};
const updateMyPasswordApi = () => {};
export default {
  name: 'XPasswordDialog',
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Form.name]: Form,
    [Button.name]: Button,
    XFormItem,
    SmsCodeInput,
    PasswordInput
  },
  /**
   * 属性参数
   * @member props
   * @property {boolean} [visible] 是否显示 Dialog
   */
  props: {
    visible: Boolean,
    checkInit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogFormVisible: true,
      hasInitPassword: true,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      },
      smsCodeForm: {
        phone: '',
        msgCode: '',
        newPassword: '',
        checkPassword: ''
      },
      pwdFormRules: {
        oldPassword: [
          {required: true, message: '请输入旧密码', trigger: 'blur'}
        ],
        newPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!isTrimEmpty(value) && isTrimEmpty(this.pwdForm.oldPassword) && value === this.pwdForm.oldPassword) {
                return callback(new Error('新密码不能与旧密码一致'));
              } else if (!checkRandomStr({str: value, length: 8, typeLimit: 3})) {
                return callback(new Error('新密码不符合规则'));
              }
              return callback();
            },
            trigger: 'blur'
          }
        ],
        checkPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.newPassword) {
                return callback(new Error('两次输入的密码不一致'));
              }
              return callback();
            },
            trigger: 'blur'
          }
        ]
      },
      smsFormRules: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
          {max: 11, message: '请输入11位手机号', trigger: 'blur'}
        ],
        msgCode: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ],
        newPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!checkRandomStr({str: value, length: 8, typeLimit: 3})) {
                return callback(new Error('新密码不符合规则'));
              }
              return callback();
            },
            trigger: 'blur'
          }
        ],
        checkPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value !== this.smsCodeForm.newPassword) {
                return callback(new Error('两次输入的密码不一致'));
              }
              return callback();
            },
            trigger: 'blur'
          }
        ]
      },
      currentTab: 'password'
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          document.body.classList.add('hack-message-box');
        } else {
          document.body.classList.remove('hack-message-box');
        }
        this.dialogFormVisible = v;
        if (v) {
          this.changePassword();
        }
      }
    },
    dialogFormVisible(v) {
      this.$emit('update:visible', v);
    }
  },
  mounted() {
    if (this.checkInit) {
      // this.checkInitPassword();
    }
  },
  methods: {
    // 判断是否初始密码
    checkInitPassword() {
      checkInitPasswordApi({}).then(response => {
        const res = response.data;
        if (res.success && res.data) {
          this.$nextTick(() => {
            this.changePassword();
            this.hasInitPassword = false;
          });
        } else {
          this.hasInitPassword = true;
          this.dialogFormVisible = false;
        }
      });
    },
    changePassword() {
      this.pwdForm = {
        oldPassword: '',
        newPassword: '',
        checkPassword: ''
      };
      this.smsCodeForm = {
        phone: getSysUser().phone,
        msgCode: '',
        newPassword: '',
        checkPassword: ''
      };
      this.dialogFormVisible = true;
    },
    // 密码修改提交事件
    onPwdFormSubmit() {
      if (this.currentTab === 'password') {
        this.$refs.pwdForm.validate((valid) => {
          if (valid) {
            const form = Object.assign({}, this.pwdForm);
            form.type = this.currentTab;
            updateMyPasswordApi(form).then(response => {
              const res = response.data;
              if (res.success) {
                this.$notify.success(res.msg); // 保存成功
                this.checkInitPassword();
                this.$emit('success');
              } else {
                this.$notify.error(res.msg); // 提示错误
              }
            });
          } else {
            this.$notify.error('请确认输入密码是否符合要求！');
          }
        });
      } else {
        this.$refs.smsCodeForm.validate((valid) => {
          if (valid) {
            const form = Object.assign({}, this.smsCodeForm);
            form.type = this.currentTab;
            delete form.phone;
            updateMyPasswordApi(form).then(response => {
              const res = response.data;
              if (res.success) {
                this.$notify.success(res.msg); // 保存成功
                this.checkInitPassword();
                this.$emit('success');
              } else {
                this.$notify.error(res.msg); // 提示错误
              }
            });
          } else {
            this.$notify.error('请确认输入密码是否符合要求！');
          }
        });
      }
    }
  }
};
</script>
<style lang="scss">
@import "../../style/mixins/index";
.x-password-dialog{
  .x-password-sms__code{
    height: 100%;
    img{
      height: 100%;
    }
  }

  .hack-message-box {
    .el-message-box__wrapper {
      display: none;
    }
  }
}
</style>